/**
 * @todo move into service
 */
export default {
    methods: {
        openBrand($event) {
            $event.preventDefault();
            $event.stopPropagation();

            const brand = this.brand;
            window.location.href = brand.link;
        }
    }
};
